<script>
  export let password;
  export let placeholder = "Password";
</script>

<input
  type="password"
  {placeholder}
  bind:value={password}
  autocomplete="current-password" />

<style>
  input {
    font-family: "Roboto", sans-serif;
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 1px solid #f2f2f2;
    margin: 0 0 15px;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: "Work Sans", sans-serif;
  }

  input:focus {
    border: 1px solid black;
  }
</style>
